export default {
  methods: {
    showTimeAndPointOfDeparture(resource, customPoint) {
      return !_.isEmpty(this.getPointFromTimeCollectionOrUseCustom(resource, customPoint));
    },

    getPointPropertyFromTimeCollectionOrUseCustom(resource, customPoint, property) {
      return _.get(this.getPointFromTimeCollectionOrUseCustom(resource, customPoint), property);
    },

    getPointFromTimeCollectionOrUseCustom(resource, customPoint) {
      let point = _.get(resource, 'timeCollection.pointCollection');
      return point ? point : customPoint;
    },

    canOrderingFromList() {
      return _.get(
        window._CONFIG_RULES,
        [
          'excursion',
          'fromUserRole',
          _.get(window._AUTHENTICATED_USER, ['roles', 0, 'id'], -1),
          'orderingFromList'
        ]
      );
    }
  }
};